/*=========================================================================================
  File Name: module-role.js
  Description: Role Module
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import state from './module-role-state';
import mutations from './module-role-mutations';
import actions from './module-role-actions';
import getters from './module-role-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
